export function readFirstQueryValue(
  value: string | string[] | undefined,
): string | undefined {
  if (Array.isArray(value)) {
    return value[0];
  }

  return value;
}

export function normalizeAuthCallbackUrl(
  rawValue: string | string[] | undefined,
  fallback = "/task-list",
): string {
  const value = readFirstQueryValue(rawValue)?.trim();
  if (!value) {
    return fallback;
  }

  if (value.startsWith("/")) {
    return value;
  }

  try {
    const parsedUrl = new URL(value);
    const relativeUrl = `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
    return relativeUrl.startsWith("/") ? relativeUrl : fallback;
  } catch {
    return fallback;
  }
}
